import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService, BaseService } from 'cre-ng';

import { AppDataService } from '@app/core/app-data.service';
import { PersonalInformation } from '@app/model/implementation/PersonalInformation';
import { IServicePersonalInformation } from '@app/model/interfaces/IServicePersonalInformation';
import { IState } from '@app/model/interfaces/IState';
import { IWithholdingStatus } from '@app/model/interfaces/IWithHoldingstatus';
import { IEmployeeService } from '@app/services/interface/IEmployeeService';

export class W4Service extends BaseService implements IEmployeeService {
  private readonly employeeEndpoint = '/v1/employee';
  private headers: HttpHeaders;
  private readonly statesEndpoint = '/v1/states';
  private readonly stateStatusEndpoint = '/v1/state/withholdingstatuses';
  private readonly alternateCalculationCodeEndpoint = '/v1/state/alternatecalculationcode';

  constructor(
    protected httpClient: HttpClient,
    protected authService: AuthService,
    private appDataService: AppDataService
  ) {
    super({ serviceApiDomain: window.__env.ngSettings.serviceApiDomain }, httpClient);
    this.headers = new HttpHeaders().set('Authorization', 'Bearer ' + this.appDataService.ticket);
    this.headers.set('Access-Control-Allow-Origin', document.baseURI);
    this.headers.set('Access-Control-Allow-Methods', 'GET, POST, PATCH, PUT, DELETE, OPTIONS');
    this.headers.set('Access-Control-Allow-Headers', 'Origin, Content-Type, X-Auth-Token');
  }

  public getEmployee(id: number): Promise<PersonalInformation> {
    return new Promise((resolve, reject) => {
      const promise = this.httpClient
        .get<any>(`${this.serviceUrl}${this.employeeEndpoint}`, { headers: this.headers })
        .toPromise();

      promise
        .then((x) => {
          resolve(new PersonalInformation(x));
        })
        .catch((x) => {});
    });
  }

  public getStates(): Promise<IState[]> {
    return this.httpClient
      .get<IState[]>(`${this.serviceUrl}${this.statesEndpoint}`, { headers: this.headers })
      .toPromise();
  }

  public getStatus(state: string): Promise<IWithholdingStatus[]> {
    return this.httpClient
      .get<IWithholdingStatus[]>(`${this.serviceUrl}${this.stateStatusEndpoint}/${state}`, {
        headers: this.headers,
      })
      .toPromise();
  }

  public getAlternateCalculationCode(state: string): Promise<IWithholdingStatus[]> {
    return this.httpClient
      .get<IWithholdingStatus[]>(
      `${this.serviceUrl}${this.alternateCalculationCodeEndpoint}/${state}`,
      {
        headers: this.headers,
      }
    )
      .toPromise();
  }

  public saveEmployee(data: IServicePersonalInformation): Promise<boolean> {
    return this.httpClient
      .post<boolean>(`${this.serviceUrl}${this.employeeEndpoint}`, data, {
        headers: this.headers,
      })
      .toPromise();
  }

  protected getEndPoint(): string {
    return '/w4/api';
  }
}
